'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.errors.not-found', ['ui.router']).config(function ($stateProvider) {
  $stateProvider.state('not-found', {
    url: '/not-found',
    controller: 'NotFoundController',
    template: require('./tpl.html')
  });
}).controller('NotFoundController', function ($scope) {
  console.log("Running not-found");
});


//////////////////
// WEBPACK FOOTER
// ./routes/errors/not-found/index.js
// module id = 534
// module chunks = 0